module.exports = __webpack_public_path__ + "static/media/premio-ana-2020.9c86e415.png";